import { IThumbnailInfo } from '../../components/core/FileCardList/FileCardListItem';

import loadPdfJsDocument from './loadPdfJsDocument';
import pageToImageDataUrl from './pageToImageDataUrl';

const PREVIEW_CACHE: Record<string, IThumbnailInfo> = {};

async function generatePdfThumbnail(pdfUrl: string) {
  if (PREVIEW_CACHE[pdfUrl] == null) {
    const pdf = await loadPdfJsDocument(pdfUrl);
    const pageImageDataUrl = await pageToImageDataUrl(pdf, 1);

    const page = await pdf.getPage(1);
    const [, , pageWidth, pageHeight] = page.view;

    PREVIEW_CACHE[pdfUrl] = {
      url: pageImageDataUrl,
      orientation: pageWidth > pageHeight ? 'landscape' : 'portrait',
      margin: 'none',
    };

    await pdf.destroy();
  }

  return PREVIEW_CACHE[pdfUrl];
}

export default generatePdfThumbnail;
